import { useTypedParams } from '@sorare/routing';

import { UserWatchlists } from '@sorare/gameplay/src/components/profile/UserWatchlists';

import { PageParams } from './__generated__/routeParams';

const Watchlists = () => {
  const { slug } = useTypedParams<PageParams>();
  return <UserWatchlists slug={slug} />;
};

export default Watchlists;
